<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      dense
      :server-items-length="total"
      :options.sync="options"
      :footer-props="{
        'items-per-page-options': [25, 50],
        'items-per-page-text': 'Mostrar',
      }"
      :loading="loading"
      loading-text="Carregando..."
    >
      <template v-slot:[`item.user_id`]="{ item }">
        <small>{{
          professionalClassCouncilValue(getUserById(item.user_id))
        }}</small>
      </template>
      <template v-slot:[`item.when`]="{ item }">
        {{ formatDate(item.when) }}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        {{ handleAction(item.action) }}
      </template>
    </v-data-table>
    <errors-messages :errors="errors" />
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";

import api from "../../../services/api";

import { formatDate, professionalClassCouncilValue } from "../../../lib/format";

export default {
  name: "Logs",

  components: {
    ErrorsMessages,
  },

  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 25,
      },

      headers: [
        { text: "Responsável", value: "user_id", sortable: false },
        { text: "Ocorrência", value: "when", sortable: false },
        { text: "Ação", value: "action", sortable: false },
      ],

      users: [],
      items: [],
      total: 0,

      loading: false,
      errors: [],
    };
  },

  props: {
    resident_id: [String, Number],
    document: { type: [Boolean, Object] },
  },

  watch: {
    options() {
      this.paginate();
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDate,
    professionalClassCouncilValue,

    async retrieve() {
      await this.getUsers();
      await this.paginate();
    },

    handleAction(action) {
      return (
        {
          CREATE: "CADASTROU",
          VIEW_IMG: "Visualizou imagem",
          VIEW_PDF: "Visualizou PDF",
          DOWNLOAD_IMG: "Fez download da imagem",
          DOWNLOAD_PDF: "Fez download do PDF",
        }[action] || "Não identificado"
      );
    },

    getUserById(id) {
      for (let user of this.users) {
        if (user.id == id) {
          return {
            id: user.professional_class_council_id,
            name: user.name,
            value: user.professional_class_council_value,
            cpf: user.cpf,
            office: user.office,
          };
        }
      }

      return {
        id: null,
        name: "DEMO",
        value: null,
        cpf: null,
        office: null,
      };
    },

    async getUsers() {
      try {
        this.loading = true;

        let response = await api.get("/rest-home/users");

        let { error, errors, users } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.users = users;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async paginate() {
      try {
        let { resident_id, document, options } = this;

        let { id } = document;

        let { page, itemsPerPage } = options;

        let params = { resident_id, document_id: id, page, itemsPerPage };

        const response = await api.get("/rest-home/history/documents", {
          params,
        });

        const { items, total } = response.data;

        this.items = items;
        this.total = total;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
